import R from 'ramda';
import React, { Component } from 'react';
import { Row, Col, FormGroup, Radio } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import { connect } from 'react-redux';
import actions from '../../redux/actions';
import getContent from '../ContractBlock/Contents/Ownership';
import ChangeRequestsView from '../Deals/DealEditPages/ChangeRequestsView';
class Ownership extends Component {
  constructor(props) {
    super(props);
    this.state = {
      block: null,
      adjust: undefined,
      adjust2: undefined,
      changes: {},
    };
  }

  options = () => ({
    composition: this.state.changes.composition,
    consent: this.state.changes.consent,
  });

  oldOptions = () => ({
    composition: this.props.composition,
    consent: this.props.consent,
  });

  getOptions() {
    const oldOptions = this.oldOptions();
    const options = this.options();

    if (this.state.adjust) {
      oldOptions.composition = options.composition;
    } else if (this.state.adjust === undefined) {
      oldOptions.composition = undefined;
    }

    if (this.state.adjust2) {
      oldOptions.consent = options.consent;
    } else if (this.state.adjust === undefined) {
      oldOptions.consent = undefined;
    }

    return oldOptions;
  }

  componentDidMount() {
    if (this.props.dealBlocks) {
      this.getBlockChanges(this.props.dealBlocks);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.dealBlocks) {
      this.getBlockChanges(nextProps.dealBlocks);
    }
  }

  getBlockChanges(dealBlocks) {
    const block = R.find(R.propEq('id', this.props.block.id))(dealBlocks);

    if (block) {
      this.setState({
        changes: block.changes || {},
        adjust: block.accept === undefined ? undefined : !block.accept,
        adjust2: block.accept2 === undefined ? undefined : !block.accept2,
      });
    }
    this.setState({ block });
  }

  handleAdjust(adjust, value) {
    const states = this.state;

    states[adjust] = value;
    this.setState(states);

    if (states.adjust === false && states.adjust2 === false) {
      this.props.removeBlockChanges(this.props.block.id);
    } else {
      const { block, agreement } = this.props;
      const options = this.getOptions();

      this.props.setBlockChanges({
        id: block.id,
        options,
        ...getContent(options, agreement.type),
        accept: states.adjust === undefined ? undefined : !states.adjust,
        accept2: states.adjust2 === undefined ? undefined : !states.adjust2,
      });
    }
  }

  handleContent(field, value) {
    const { contractBlocks } = this.props;

    const options = this.options();
    options[field] = value;

    if (this.state.block && field === 'composition' && value === 1) {
      this.props.alert(
        'error',
        'You have selected an option that requires you to change your answers in the Payment tab next.'
      );
    }

    if (this.state.block && field === 'composition' && value === 0) {
      // Remove payment statutory percent if the composition value is 0
      const paymentBlock = contractBlocks.find(
        (block) => block.name === 'Payments'
      );
      if (
        paymentBlock.options &&
        paymentBlock.options.statutoryPercentage !== ''
      ) {
        const paymentOptions = {
          ...paymentBlock.options,
          statutoryPercentage: '',
        };
        this.props.setBlockChanges({
          id: paymentBlock.id,
          paymentOptions,
          ...getContent(paymentOptions),
        });
      }
    }

    this.props.setBlockChanges({
      id: this.props.block.id,
      options,
      ...getContent(options),
      accept: this.state.adjust === undefined ? undefined : !this.state.adjust,
      accept2:
        this.state.adjust2 === undefined ? undefined : !this.state.adjust2,
    });
  }

  renderAdjust() {
    const { adjust, changes } = this.state;

    if (adjust === true) {
      return (
        <div>
          <FormGroup className="answer">
            <Radio
              name="composition"
              checked={changes.composition === 0}
              readOnly
              onClick={(e) => this.handleContent('composition', 0)}
            >
              No
            </Radio>
            <Radio
              name="composition"
              checked={changes.composition === 1}
              readOnly
              onClick={(e) => this.handleContent('composition', 1)}
            >
              Yes
            </Radio>
          </FormGroup>
        </div>
      );
    } else {
      return null;
    }
  }

  renderAdjust2() {
    const { adjust2, changes } = this.state;

    if (adjust2 === true) {
      return (
        <div>
          <FormGroup className="answer">
            <Radio
              name="consent"
              checked={changes.consent === 0}
              readOnly
              onClick={(e) => this.handleContent('consent', 0)}
            >
              No
            </Radio>
            <Radio
              name="consent"
              checked={changes.consent === 1}
              readOnly
              onClick={(e) => this.handleContent('consent', 1)}
            >
              Yes
            </Radio>
          </FormGroup>
        </div>
      );
    } else {
      return null;
    }
  }

  renderChangeRequest(changeRequest) {
    let content = '';
    if (changeRequest.changes.composition === 1) {
      content =
        'Yes, producer will have a claim of ownership or authorship of the musical compositions.';
    } else if (changeRequest.changes.composition === 0) {
      content =
        'No, producer will not have a claim of ownership or authorship of the musical compositions.';
    }
    if (changeRequest.changes.consent === 1) {
      content +=
        'Yes, the producer can distribute, display, reproduce, or otherwise use the recordings without written permission.';
    } else if (changeRequest.changes.consent === 0) {
      content +=
        'No, the producer cannot distribute, display, reproduce, or otherwise use the recordings without written permission.';
    }

    return content;
  }

  renderChangeRequests(type) {
    let changeRequests = [];
    if (type === 0) {
      changeRequests = this.props.changeRequests;
    } else {
      changeRequests = this.props.changeRequests2;
    }

    return (
      <ChangeRequestsView
        changeRequests={changeRequests}
        renderChangeRequest={(changeRequest) =>
          this.renderChangeRequest(changeRequest)
        }
      />
    );
  }

  render() {
    return (
      <div className="tab-content">
        <Row>
          {!this.props.finalized && !this.props.isAttorney && (
            <Col sm={12}>
              <p className="question">
                Does the Producer have a claim of ownership or authorship of the
                musical composition(s)?
              </p>
              <FormGroup className="answer">
                <Radio
                  name="contribution-adjust"
                  checked={this.state.adjust === false}
                  readOnly
                  onClick={(e) => this.handleAdjust('adjust', false)}
                >
                  {this.props.userInfo.same
                    ? `Keep my original proposal: `
                    : `Accept ${this.props.userInfo.name} 's proposed terms: `}
                  {this.props.composition === 1 ? 'Yes.' : 'No.'}
                </Radio>
                <hr />
                <Radio
                  name="contribution-adjust"
                  checked={this.state.adjust === true}
                  readOnly
                  onClick={(e) => this.handleAdjust('adjust', true)}
                >
                  {this.props.userInfo.same
                    ? `Change my proposal:`
                    : `Suggest an alternative:`}
                </Radio>
                {this.renderAdjust()}
              </FormGroup>
              {this.props.renderAccepts()}
              {this.renderChangeRequests(0)}
              <br />

              <p className="question">
                Can the Producer distribute, display, reproduce, or otherwise
                use the recording(s) without written permission?
              </p>
              <FormGroup className="answer">
                <Radio
                  name="contribution-adjust2"
                  checked={this.state.adjust2 === false}
                  readOnly
                  onClick={(e) => this.handleAdjust('adjust2', false)}
                >
                  {this.props.userInfo.same
                    ? `Keep my original proposal: `
                    : `Accept ${this.props.userInfo.name} 's proposed terms: `}
                  {this.props.consent === 1 ? 'Yes.' : 'No.'}
                </Radio>
                <hr />
                <Radio
                  name="contribution-adjust2"
                  checked={this.state.adjust2 === true}
                  readOnly
                  onClick={(e) => this.handleAdjust('adjust2', true)}
                >
                  {this.props.userInfo.same
                    ? `Change my proposal:`
                    : `Suggest an alternative:`}
                </Radio>
                {this.renderAdjust2()}
              </FormGroup>
              {this.props.renderAccepts2()}
              {this.renderChangeRequests(1)}
            </Col>
          )}
          {!this.props.finalized && !this.props.isAttorney && (
            <Col sm={12}>{this.props.children}</Col>
          )}

          <Col sm={12}>
            <div className="notes">
              <h4>
                <FontAwesome name="question-circle" />
                Need Some Help?
              </h4>
              <div className="expand" tabIndex="0">
                <p className="question">Why is this important?</p>
                <p className="small">
                  Taking the time now to outline permissions around the usage of
                  the music clears up any confusion and helps you to avoid
                  serious legal and financial issues caused by using the music
                  without proper permission.
                </p>
                <p className="small">
                  Under this agreement, the Producer will not own any of the
                  master(s). If the Producer owns a part of the musical
                  composition(s), there are other questions Cosynd will need to
                  ask you in the “Payments” section. You will also need to
                  attach a copyright split agreement (“split sheet”) to your
                  Producer agreement after it is completed.&nbsp; If you don't
                  have a split sheet in place, you can create one for free on
                  Cosynd.
                </p>
              </div>
              <div className="expand" tabIndex="1">
                <p className="question">What is a "musical composition?"</p>
                <p className="small">
                  A song is composed of two copyrights: 1) the sound recording
                  (the master) and 2) the musical composition (the written
                  lyrics and musical arrangement). A musical composition
                  consists of the written melody, notation, musical arrangement,
                  and lyrics.
                </p>
                <p className="small">
                  Under this agreement, the Producer will not own the sound
                  recording(s). If they do own a portion of the musical
                  composition(s), you should indicate that here now.
                </p>
              </div>
              <div className="expand" tabIndex="2">
                <p className="question">
                  What will I need if a Producer has a claim of
                  ownership/authorship of the musical composition(s)?
                </p>
                <p className="small">
                  After you have completed your Producer agreement, you should
                  attach a copyright split agreement (“split sheet”) to it for
                  each song that outlines all of the owners of the musical
                  composition(s). If you don’t already have a split sheet
                  agreement, you can create split sheets on Cosynd for free.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  alert: (type, msg) => {
    dispatch(actions.alert(type, msg));
  },
});

export default connect(null, mapDispatchToProps)(Ownership);



// WEBPACK FOOTER //
// src/components/DealContractBlock/Ownership.jsx